import NextLink, { LinkProps as NextLinkProps } from 'next/link';
import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { tv, VariantProps } from 'tailwind-variants';

import { button } from './Button';

export const link = tv({
  base: [
    'focus-visible:ring-zmyle-secondary outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-offset-2',
  ],

  variants: {
    variant: {
      primary: 'hover:text-dynamic-accent transition-colors hover:underline',
      ghost: '',
      'primary-button': twMerge(button.base, button.variants.variant.primary),
      'outline-button': twMerge(button.base, button.variants.variant.outline),
      'store-button': twMerge(button.base, button.variants.variant.store),
      'benefit-button': twMerge(button.base, button.variants.variant.benefit),
      'network-button': twMerge(button.base, button.variants.variant.network),
    },
  },

  defaultVariants: {
    variant: 'primary',
  },
});

export type LinkProps = NextLinkProps &
  ComponentProps<'a'> &
  VariantProps<typeof link> & {
    isExternal?: boolean;
  };

export function Link({ className, variant, isExternal, ...props }: LinkProps) {
  const classNames = link({ variant, className });

  if (isExternal) {
    return <a className={classNames} target="_self" {...props} />;
  }

  return <NextLink className={classNames} {...props} />;
}
